<mat-stepper
    #stepper
    (selectionChange)="handleSelectionChange($event)"
    [(selectedIndex)]="selectedIndex"
    class="se-stepper themed-class"
    [ngClass]="{ 'error-header': hasErrors(), 'header-disabled': disableHeader }"
    linear
    style="height: 100%; position: relative"
>
    <mat-step
        *ngFor="let step of seSteps; let i = index"
        [completed]="step.isCompleted"
        [errorMessage]="step.errorMessage"
        [hasError]="step.hasError"
        [ngClass]="{ 'selected-step': i === stepper.selectedIndex }"
        [optional]="step.isOptional"
        [stepControl]="step.form$ | async"
        class="se-step"
        [class.readonly]="step.readOnly"
    >
        <ng-template matStepLabel
            ><span
                [matTooltipClass]="step.hasError ? 'step-tooltip error' : 'step-tooltip'"
                [matTooltipHideDelay]="tooltipHideDelay"
                [matTooltip]="step.tooltipMessage"
                class="step-label-container"
                [class.readonly]="step.readOnly"
                [matTooltipPosition]="matTooltipPosition"
                >{{ step.title }}
            </span></ng-template
        >

        <ng-container [ngTemplateOutlet]="step.content"></ng-container>
    </mat-step>
</mat-stepper>

<button
    (click)="prev()"
    *ngIf="afterInitCompleted && selectedIndex > 0"
    class="step-button prev"
    color="primary"
    mat-icon-button
>
    <mat-icon class="stepper-prev-icon">chevron_left</mat-icon>
</button>
<button
    *ngIf="afterInitCompleted && selectedIndex < seSteps.length - 1"
    [disabled]="
        seSteps.get(selectedIndex)?.hasError ||
        (!seSteps.get(selectedIndex)?.isCompleted && !seSteps.get(selectedIndex)?.isOptional)
    "
    color="primary"
    mat-icon-button
    class="step-button next"
    (click)="next()"
>
    <mat-icon class="stepper-next-icon">chevron_right</mat-icon>
</button>
